export const FETCH_STORES = 'store/FETCH_STORES'
export const FETCH_STORES_SUCCESS = 'store/FETCH_STORES_SUCCESS'
export const FETCH_STORES_FAILURE = 'store/FETCH_STORES_FAILURE'
export const RESET_STORES = 'store/RESET_STORES'

export const FETCH_STORE = 'store/FETCH_STORE'
export const FETCH_STORE_SUCCESS = 'store/FETCH_STORE_SUCCESS'
export const FETCH_STORE_FAILURE = 'store/FETCH_STORE_FAILURE'
export const RESET_STORE = 'store/RESET_STORE'

export const CREATE_STORE = 'store/CREATE_STORE'
export const CREATE_STORE_SUCCESS = 'store/CREATE_STORE_SUCCESS'
export const CREATE_STORE_FAILURE = 'store/CREATE_STORE_FAILURE'
export const RESET_CREATE_STORE = 'store/RESET_CREATE_STORE'

export const UPDATE_STORE = 'store/UPDATE_STORE'
export const UPDATE_STORE_SUCCESS = 'store/UPDATE_STORE_SUCCESS'
export const UPDATE_STORE_FAILURE = 'store/UPDATE_STORE_FAILURE'
export const RESET_UPDATE_STORE = 'store/RESET_UPDATE_STORE'

export const DELETE_STORE = 'store/DELETE_STORE'
export const DELETE_STORE_SUCCESS = 'store/DELETE_STORE_SUCCESS'
export const DELETE_STORE_FAILURE = 'store/DELETE_STORE_FAILURE'
export const RESET_DELETE_STORE = 'store/RESET_DELETE_STORE'


// WEBPACK FOOTER //
// ./src/store/store/actionTypes.js